import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../common/DashboardApp";
import { paymentHistory } from "../../../service/employerapi";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const PaymentHistory = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [applications, setApplication] = useState([]);
  const [btnloading, setBtnLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  useEffect(() => {
    if (location.state?.toastMessage) {
      toast.success(location.state.toastMessage);
    }

    const fetchApplications = async () => {
      try {
        setLoading(true);
        const response = await paymentHistory();
        console.log(response);

        setApplication(response.data?.paymentList || []);
      } catch (err) {
        console.error("Error fetching Applications:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchApplications();
  }, []);

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="panelCard">
          <div className="titlSectionu userpaneltitle text-left position-relative">
            <h2>Payment History</h2>
          </div>

          {loading ? (
            <div className="text-center w-100 my-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : applications.length === 0 ? (
            <div className="col-12">
              <div className="alert alert-info text-center">
                No Payments Done.
              </div>
            </div>
          ) : (
            <table className="table mt-4 hj-table">
              <thead>
                <tr>
                  <th scope="col">Sl. No.</th>
                  <th scope="col">Jobseeker</th>
                  <th scope="col">Amount Paid</th>
                  <th scope="col">Total Hours</th>
                  <th scope="col">Approved Task</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {applications.map((application, index) => (
                  <tr key={application.applicationId || index}>
                    <td>{index + 1}</td>

                    <td>
                      <div className="transactiondinfo">
                        <h5>{application.jobSeekerName}</h5>
                        {/* <p>+91 {application.phoneNumber}</p> */}
                        <p>{application.email}</p>
                      </div>
                    </td>

                    <td>
                      <div className="transactiondinfo">
                        <h5>₹{application.totalAmount}</h5>
                      </div>
                    </td>

                    <td>
                      <div className="transactiondinfo">
                        <h5>{application.totalHours}</h5>
                      </div>
                    </td>

                    <td>
                      <div className="transactiondinfo">
                        <h5>{application.approvedTasks}</h5>
                      </div>
                    </td>
                    <td>
                      <button
                        className="mainbtn"
                        onClick={() => {
                          setSelectedPayment(application);
                          setShowModal(true);
                        }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {showModal && selectedPayment && (
            <div className="modal fade show" style={{ display: "block" }}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Payment Details</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowModal(false)}
                    ></button>
                  </div>

                  <div className="modal-body">
                    <p>
                      <strong>Jobseeker:</strong>{" "}
                      {selectedPayment.jobSeekerName}
                    </p>
                    <p>
                      <strong>Phone:</strong> {selectedPayment.phoneNumber}
                    </p>
                    <p>
                      <strong>Email:</strong> {selectedPayment.email}
                    </p>
                    <p>
                      <strong>Total Hours:</strong> {selectedPayment.totalHours}
                    </p>
                    <p>
                      <strong>Approved Tasks:</strong>{" "}
                      {selectedPayment.approvedTasks}
                    </p>
                    <p>
                      <strong>Total Amount:</strong> ₹{selectedPayment.totalAmount}
                    </p>
                    <p>
                      <strong>Payment Date:</strong>{" "}
                      {new Date(selectedPayment.paymentDate).toLocaleString()}
                    </p>
                    <p>
                      <strong>Paid:</strong>{" "}
                      {selectedPayment.isPaid ? "Paid" : "Not Paid"}
                    </p>
                    <p>
                      <strong>Payment Id:</strong>{" "}
                      {selectedPayment._id}
                    </p>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="mainbtn"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PaymentHistory;
